import Header from './Header';
import { Outlet } from 'react-router';
import Footer from './Footer';
import { Box, Container } from '@mui/joy';
import React from 'react';

function Layout({ children }: { children?: React.ReactNode }) {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
        }}>
            <Header />

            <Container disableGutters
                       component="main">

                {children || <Outlet />}

            </Container>

            <Box sx={{
                mt: 'auto',
            }}>
                <Footer />
            </Box>
        </Box>
    );
}

export default Layout;